import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isEqual, isObject } from 'lodash';

export function differentValueValidator(defaultValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (isObject(defaultValue)) {
            return isEqual(control.value, defaultValue) ? { differentValue: true } : null;
        }

        return isEqual(control.value, defaultValue) ? { differentValue: true } : null;
    };
}
